export enum PublicationType {
  PUBLISH_IMMEDIATE = "0",
  POSTPONE_TILL_DATE = "1",
}
